module.exports = __webpack_public_path__ + "static/media/BS_O_Timeless_Sforza_LTGrey.653f8eaf.png";